/**
 * 설치사례 보드 — API 실패 시 공개 페이지용 정적 fallback (게시된 사례 형태).
 * facility_type: apt | shop | office | public | etc
 */
export type InstallCaseItem = {
  id: string;
  title: string;
  facility_type: 'apt' | 'shop' | 'office' | 'public' | 'etc';
  region: string;
  charger_count: string;
  install_type: string;
  summary: string;
  description: string;
  main_image_url: string;
  image_1_url?: string;
  image_2_url?: string;
  image_3_url?: string;
};

export const INSTALL_CASE_ITEMS: InstallCaseItem[] = [
  {
    id: 'static-1',
    title: '공동주택 단지 · 지하주차장 증설 검토',
    facility_type: 'apt',
    region: '수도권',
    charger_count: '완속 4대',
    install_type: '위탁운영',
    summary: '기존 전력 여유와 주차면 배치를 고려한 단계적 증설 검토 사례입니다.',
    description:
      '입주민 이용 동선과 전기실 거리를 기준으로 설치 위치를 조정하고, 단계적 증설로 비용을 분산하는 방안을 검토했습니다.',
    main_image_url: '',
  },
  {
    id: 'static-2',
    title: '상업시설 · 방문객 주차층 충전 구역',
    facility_type: 'shop',
    region: '지방 광역시',
    charger_count: '급속 2대',
    install_type: '수익형',
    summary: '이용 패턴이 뚜렷한 상업시설에서의 운영·표시 계획을 함께 정리했습니다.',
    description:
      '방문객 피크 시간대와 상주 차량을 구분해 운영 규정 초안을 마련하고, 안내 표지와 요금 체계를 정리했습니다.',
    main_image_url: '',
  },
  {
    id: 'static-3',
    title: '업무시설 · 임직원 전용 충전',
    facility_type: 'office',
    region: '수도권',
    charger_count: '완속 6대',
    install_type: '자가설치',
    summary: '근무 시간대 집중 이용을 가정한 수요 산정과 안내 동선을 반영했습니다.',
    description:
      '임직원 전용 구역과 방문 차량 구역을 분리하고, 예약제 도입 여부를 포함해 운영 시나리오를 비교했습니다.',
    main_image_url: '',
  },
  {
    id: 'static-4',
    title: '공공기관 · 시민 개방형 주차장',
    facility_type: 'public',
    region: '지방',
    charger_count: '완속 8대',
    install_type: '보조사업',
    summary: '공공성과 이용 균형을 맞추기 위한 정책 정리 단계를 포함한 검토입니다.',
    description:
      '개방 시간·요금·장애인 주차 구역과의 관계 등을 검토하고, 민원 대응 시나리오를 문서화했습니다.',
    main_image_url: '',
  },
];

/** 설치사례 카드 — 건물 유형 배지 (`ev123-badge` + modifier) */
export function installCaseFacilityBadgeClass(facilityType: string): string {
  const ft = (facilityType || 'etc').trim();
  if (ft === 'apt' || ft === 'shop' || ft === 'office' || ft === 'public' || ft === 'etc') {
    return `ev123-badge ev123-badge--facility-${ft}`;
  }
  return 'ev123-badge ev123-badge--facility-etc';
}

const INSTALL_TYPE_TO_MODIFIER: Record<string, string> = {
  자가설치: 'install-self',
  위탁운영: 'install-operate',
  보조사업: 'install-subsidy',
  수익형: 'install-revenue',
  교체설치: 'install-replace',
  이전설치: 'install-move',
  기타: 'install-other',
};

/** 설치사례 카드 — 설치 방식 배지 */
export function installCaseInstallTypeBadgeClass(installType: string): string {
  const t = (installType || '').trim();
  const mod = INSTALL_TYPE_TO_MODIFIER[t];
  if (mod) return `ev123-badge ev123-badge--${mod}`;
  return 'ev123-badge ev123-badge--install-other';
}
